// extracted by mini-css-extract-plugin
export default {"info":"Profile_info__u7YzJ","basic":"Profile_basic__Ia6xq","username":"Profile_username__y0lwT","formContent":"Profile_formContent__li9JT"};